import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { calendarFile, canExport, googleCalendarUrl } from './personalCalendar';

export default function PersonalCalendarButtons({ event, store, dirty = false }) {
  const [error, setError] = useState('');
  if (!event || event.status === 'Cancelled' || !canExport(event)) return null;
  function download() {
    try {
      const url = URL.createObjectURL(new Blob([calendarFile(event, store)], { type: 'text/calendar;charset=utf-8' }));
      const a = document.createElement('a'); a.href = url; a.download = `mhc-appointment-${event.id}.ics`;
      document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000);
      setError('');
    } catch (_) { setError('Could not download this appointment. Try again.'); }
  }
  return <div className="mt-3">
    <strong className="d-block mb-2">Add to your personal calendar</strong>
    {dirty ? <p className="small">Save your changes first to copy the updated appointment.</p> : <>
      <Button as="a" href={googleCalendarUrl(event, store)} target="_blank" rel="noopener noreferrer" variant="outline-primary" size="sm" className="mr-2 mb-2">Add to Google Calendar</Button>
      <Button type="button" onClick={download} variant="outline-secondary" size="sm" className="mb-2">Download for Outlook / Apple (.ics)</Button>
    </>}
    <p className="small text-muted mb-0">Choose your calendar and save there. This creates a copy; update or remove it manually if the CRM appointment changes. Adding again may create a duplicate.</p>
    {error && <p role="alert" className="text-danger">{error}</p>}
  </div>;
}
